import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useDidMount, useStateWithCallback } from "../../utils/hooks";
import { pexios, getQueryString, getDirection } from '../../utils/functions';
import { history } from '../../utils/variables';
import { setRouterData } from '../../redux/actions';
import Moment from 'moment-jalaali';
import Pagination from '../../components/master/Pagination';
import { useTranslation } from 'react-i18next';

// const status ={ 
//     '-10': 'در حال کارشناسی',
//     '0': 'در انتظار بررسی',
//     '10': 'آماده بازدید مجدد',
//     '11' : 'بازدید مجدد شد',
//     '6' : 'آماده تحویل داغی',
//     '7': 'تحویل داغی شد',
//     '3': 'آماده بازدید سلامت',
//     '4': 'بازدید سلامت شد',
//     '12': 'آماده شورا',
//     '13': 'شورایی شد',
//     '8': 'در انتظار تایید 1',
//     '9': 'در انتظار تایید 2',
//     '91' : 'در انتظار تایید 3',
//     '1': 'تایید',
//     '2': 'رد',
//     '5': 'پرداخت شد',
//     '20' : 'مختومه'
// }


export default function ReportList() {
    const { t, i18n } = useTranslation();
    const user = useSelector((store) => store.user);
    const dispatch = useDispatch();

    const [reports, setReports] = useState([]);
    const [loader, setLoader] = useState(false);
    const [accidentId, setAccidentId] = useState(null);
    const [currentPage, setCurrentPage] = useStateWithCallback(1);
    const [lastPage, setLastPage] = useState(1);
    const [reportStatus, setReportStatus] = useState(getQueryString('status'));

    const status ={ 
        'e-10': t('Experting'),
        'e0': t('Waiting to check'),
        'e10': t('Ready to visit again'),
        'e11' : t('Visit again done'),
        'e6' : t('Ready to give damage accessories'),
        'e7': t('Give damage accessories done'),
        'e3': t('Ready to health visit'),
        'e4': t('Health visit done'),
        'e12': t('Ready to council'),
        'e13': t('Council done'),
        'e8': t('Waiting to confirmation1'),
        'e9': t('Waiting to confirmation2'),
        'e91' : t('Waiting to confirmation3'),
        'e1': t('Confirm'),
        'e2': t('Disapproval'),
        'e5': t('Paied'),
        'e20' : t('Closed')
    }

    const loadReports = useCallback((page = 1) => {
        setLoader(true);
        const api = `api/v2/get_${user.type === 'expert' ? 'expert' : 'my'}_report?page=${page}`;
        const params = `${accidentId ? `&accident_id=${accidentId}` : ''}${reportStatus ? reportStatus === 'all'? '': `&status=${reportStatus}` : ''}`;
        pexios(`${api}${params}`)
            .then(res => {
                const result = res.data;
                setLoader(false);
                setReports(result.data);
                setLastPage(result.meta.last_page);
            });
    }, [accidentId, reportStatus, user.type]);

    useDidMount(() => loadReports());

    function search() {
        setCurrentPage(1);
        loadReports(1);
    }
    function changePage(page) {
        setCurrentPage(page, (currentPage) => loadReports(currentPage));
    }

    function goToDetails(id) {
        dispatch(setRouterData({ id, type: 'report' }));
        history.push('/report-single');
    }
    return (
        <div className='content report'>
            <div className={`d-flex mb10 ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse':''}`}>
                <button className={`btn btn-green ${`${getDirection(i18n.language) === 'leftToRight' ? 'btn-circle-right':'btn-circle-left'}`}`} onClick={search} disabled={loader}>
                    {t('Search')}
                </button>
                <div className={`input-parent ${getDirection(i18n.language) === 'leftToRight' ? 'ltr':'rtl'} flex1`}>
                    <select
                        className='no-radius'
                        value={reportStatus}
                        onChange={(e) => setReportStatus(e.target.value)}
                    >
                        <option value={'all'}>{t('All state')}</option>
                        {
                            Object.keys(status).map(key => <option key={key.slice(1)} value={key.slice(1)}>{status[key]}</option>)
                        }
                    </select>
                </div>
                <div className={`input-parent ${getDirection(i18n.language) === 'leftToRight' ? 'ltr':'rtl'} flex1`}>
                    <input
                        className={`${getDirection(i18n.language) === 'leftToRight' ? 'circle-left':'circle-right'}`}
                        type='number'
                        placeholder={t('Search')}
                        onChange={e => setAccidentId(e.target.value)}
                    />
                </div>
            </div>
            <div className='text-center'>
                {
                    loader ?
                        <i className='fa fa-spinner fa-spin' /> :
                        <table className={`${getDirection(i18n.language) === 'leftToRight' ? 'ltr':'rtl'}`}>
                            <thead>
                            <tr>
                                <td className='text-center'>{t('File')}</td>
                                <td className='text-center'>{t('Accident')}</td>
                                <td className='text-center'>{t('State')}</td>
                                <td className='text-center'>{t('Date')}</td>
                                <td className='text-center'>{t('Operation')}</td>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                reports.map((report, index) => (
                                    <tr key={index}>
                                        <td className='text-center'>{report.id}</td>
                                        <td className='text-center'>{report.accident_id}</td>
                                        <td className='text-center'>
                                            { status[`e${(report.status).toString()}`] }
                                            
                                        </td>
                                        <td className='text-center'>
                                            { Moment(report.created_at).format('jYYYY/jM/jD') }
                                        </td>
                                        <td className='text-center'>
                                            <button
                                                onClick={() => goToDetails(report.id)}
                                                className={
                                                    `btn btn-sm btn-circle btn-${[-10, 3, 6, 10].includes(report.status) ? 'red' : 'green'}`
                                                }
                                            >
                                                {t('Watch')}
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </table>

                }
                <div className='mt20'>
                    <Pagination
                        currentPage={currentPage}
                        total={lastPage}
                        changePage={changePage}
                    />
                </div>
            </div>
        </div>
    );

}
